import Image, { ImageProps } from 'next/image';
import { useState } from 'react';
import { NEXT_PUBLIC_IMAGE_DOMAIN } from '@/lib/env';
import LazyLoadImageWrapper from './organisms/Restaurant/Item/styles';

const defaultQuality = 40;

const CloudfrontLoader = (props) => {
  const { src, width, quality } = props;
  const url = new URL(src);
  const pathParts = url.pathname.split('/').filter(Boolean);
  const dimensions = pathParts
    .shift()
    .split('x')
    .map((string) => parseInt(string, 10));

  const [srcWidth, srcHeight] = dimensions;
  const newHeight = Math.round((srcHeight / srcWidth) * width);

  return [
    url.origin,
    // Don't go larger than 2x (retina) the width/height of the original image
    `${Math.min(width, srcWidth * 2)}x${Math.min(newHeight, srcHeight * 2)}`,
    `filters:quality(${quality || defaultQuality})`,
    ...pathParts,
  ].join('/');
};

const CloudfrontImage = (props: ImageProps) => {
  const { src } = props;
  const [loading, setLoading] = useState(true);
  let loader = null;

  // Check src includes a cloudfront url
  if (typeof src === 'string' && src.includes(NEXT_PUBLIC_IMAGE_DOMAIN)) {
    loader = CloudfrontLoader;
  }

  return (
    <LazyLoadImageWrapper className={loading && 'loading'} as="span">
      <Image
        {...props}
        loader={loader}
        onLoad={() => {
          setLoading(false);
        }}
      />
    </LazyLoadImageWrapper>
  );
};

export default CloudfrontImage;
